import { render, staticRenderFns } from "./AdiRichiestaVisitaSpecialisticaDomiciliareComponent.vue?vue&type=template&id=52be8285"
import script from "./AdiRichiestaVisitaSpecialisticaDomiciliareComponent.vue?vue&type=script&lang=js"
export * from "./AdiRichiestaVisitaSpecialisticaDomiciliareComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports